export default "__VITE_ASSET__FwAKq92Q__"